<app-organizer-timeslot-edition-shared-select-timeslots
  [previousUrl]="previousUrl"
  [activity]="activity"
  [timeslots]="timeslots"
  [formControl]="selectedTimeslots"
  (updateTimeslots)="updateTimeslots()"
>
</app-organizer-timeslot-edition-shared-select-timeslots>
